;(function($){

    function Instagram() {

        var _     = this;
        
        _.show    =  "9";
        _.userId  = "9a24903d28e64c3cbd9827a7ffa5c845";
        _.token   = "230893631.9a24903.32c5290147844d73a8f2a85eed8508a8";
        _.hashtag = "probeleza";
        
        _.get();
    }

    Instagram.prototype.get =  function() {
        var _ =  this;

        $(".instagram-box").instagram({
            show: _.show,
            userId:  _.userId,
            accessToken:  _.token,
            hashtag: _.hashtag
        });
    };

   	new Instagram();

}(jQuery));
 